module.exports = __webpack_public_path__ + "media/card_animation.922a4237.mp4";